import type { JSX } from 'react';
import DSBox from '../../design-system/DSBox';
import Contract from '../../components/Contract';

const TermsAndConditions = (): JSX.Element => {
  return (
    <DSBox
      sx={{
        display: 'flex',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#1E1E1E',
        overflowY: 'auto',
        boxSizing: 'border-box',
        padding: {
          xs: '24px 16px',
          sm: '40px 32px',
          md: '60px 40px',
        },
      }}
    >
      <DSBox
        sx={{
          maxWidth: '900px',
          width: '100%',
        }}
      >
        <Contract />
      </DSBox>
    </DSBox>
  );
};

export default TermsAndConditions;
